import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { formikResetPatientNewPassword } from "../Constant";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Loader from "../../../components/Loader/Loader";
import { resetPatientNewPassword } from "../../../api/patient";
import { failed, success } from "../../../utils/Tostify";
import { decryptData, encryptData } from "../../../utils/helper";
import { decryptPatientData, maskEmail, maskPhoneNumber } from "../../../utils/common";
import phone from "../../../assets/images/phone.png";
import { getPatientDetails, resendOtp, verifyOtp } from "../../../api/auth";
import OtpInput from "react-otp-input";

function PatientRegistration() {
const [isLoading, setIsLoading] = useState(false);
const [isChecked, setIsChecked] = useState(false);
const queryParams = new URLSearchParams(window.location.search);
const [patientDetails, setPatientDetails] = useState();
const [showOtpInput, setShowOtpInput] = useState(false);
const [otp, setOtp] = useState("");
const [isOtpVerified, setIsOtpVerified] = useState(false);
const [isOtpSent, setIsOtpSent] = useState(false);
const token = queryParams.get('token');
const [patientEmail, setPatientEmail] = useState();
  const getUser = async () => {
    let res;
    try {
        setIsLoading(true);
        res = await getPatientDetails({ values: {token : token}, dispatch });
        if (res?.status !== "SUCCESS" || !res.data) {
          console.error("Unexpected or empty response:", res);
          navigate("/not-found");
          return;
        }
        localStorage.setItem("REACT_APP_ENCRYPT_KEY",res.data.ENCRYPT_KEY);
        localStorage.setItem("REACT_APP_ADOBE_READER_CLIENT_ID",res.data.ADOBE_FRONT_KEY);
        const responseData = await decryptData(res.data.data);
        const decryptedPatient = await decryptPatientData(responseData);
        if (res?.status === "SUCCESS") {
            setPatientDetails(decryptedPatient);
            setPatientEmail(decryptedPatient.telecom[0]?.value);
            setIsLoading(false);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
};

  useEffect(() => {
    if(token){
      getUser();
    }
  }, [token]);


  const dispatch = useDispatch();
  const navigate = useNavigate();
	const formik = useFormik({
    ...formikResetPatientNewPassword,
    onSubmit: async (values) => {
      let res;
      try {
        setIsLoading(true);
        const payload = {...values , email: await encryptData(JSON.stringify(patientEmail)) ,userId: patientDetails?._id};
        res = await resetPatientNewPassword({ values: payload, dispatch });
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
          navigate("/login");
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const handleSendOtp = async()=>{
    let res;
    try {
      setIsLoading(true);
      const payload = {email: patientEmail};
        res = await resendOtp({ values: payload, dispatch });
      if (res?.status === "SUCCESS") {
        setIsLoading(false);
        setShowOtpInput(true);
        setIsOtpSent(true);
        success(res?.message);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  const handleOtpChange = async (otpValue) => {
    setOtp(otpValue);
    formik.setFieldValue("otp", otpValue);
    if (otpValue.length === 6) {
      setIsLoading(true);
      try {
        const res = await verifyOtp({ values: { email: patientEmail, otp: otpValue }, dispatch });
        if (res?.status === "SUCCESS") {
          success("OTP verified successfully.");
          setIsOtpVerified(true);
        } else {
          failed("Invalid OTP. Please try again.");
        }
      } catch (error) {
        failed("Error verifying OTP.");
      } finally {
        setIsLoading(false);
      }
    }
  };

	return (
    <>
      {isLoading ? <Loader /> : null}
      <div className="page-wrapper full-page">
        <div className="header-wrapper w-nav">
          <div className="container-default w-container">
            <div className="header-content-wrapper">
              <div className="header-middle header-v3">
                <a>
                <img src="/assets/icons/group_logo_carematics.svg" alt="text_logo" className="logo_png" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="section sign-in-section patient_reg">
          <div className="image-container sign-in-section">
            <div className="image-wrapper shape section-hero---sign-in---shape-01">
              <img src="/assets/icons/WELCOME-YELLOW-CIRCLE.svg" alt="" />
            </div>
            <div className="position-absolute sign-in-shape-wrapper">
              <div className="image-wrapper shape section-hero---sign-in---shape-02">
                <img src="/assets/icons/WELCOME-BLUE-LINES.svg" alt="" />
              </div>
              <div className="image-wrapper transform-origin-bottom">
                <img src="/assets/icons/WELCOME-RED-CIRCLE.svg" alt="" />
              </div>
              <div className="image-wrapper">
                <img src="/assets/icons/WELCOME-RECTANGLE.svg" alt="" />
              </div>
            </div>
          </div>
          <div className="container-default z-index-1 width-100 w-container">
            <div className="inner-container _640px center">
              <div className="text-center mg-bottom-48px forgot">
                <h1 className="display-1 mg-bottom-8px welcom_blk forgot">
                  Register Account
                </h1>
                <p className="color-neutral-700 mg-bottom-0 welcom_desc">
                    Already registered as a user ?{" "}
                    <a href="/login" className="text-blue-600 hover:underline">
                        Sign In
                    </a>
                </p>
              </div>
              <div className="card sign-up-form shadow-02 w-form login_form">
                <Form onSubmit={formik.handleSubmit} className="form_block">
                <FormGroup className="spacing_three">
                <Input
                    id="email"
                    name="email"
                    placeholder="Email"
                    type="email"
                    value={patientDetails && maskEmail(patientDetails?.telecom[0]?.value)}
                    readOnly
                    disabled={true}
                />
                    <img src="/assets/icons/welcom-email.svg" alt="text_logo" />
                  </FormGroup>
                  <FormGroup className="spacing_three">
                    <Input
                      id="telecom"
                      name="telecom"
                      placeholder="phone"
                      type="phone"
                      disabled={true}
                      value={patientDetails && maskPhoneNumber(patientDetails?.telecom[1]?.value)}
                      onChange={formik.handleChange}
                    />
                    <img src={phone} alt="text_logo" />
                  </FormGroup>
                  <br></br>
                  {showOtpInput && (
                  <FormGroup className="spacing_three">
                     <OtpInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      shouldAutoFocus={!isOtpVerified}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => <input {...props}  disabled={isOtpVerified} />}
                      inputStyle={{
                        border: "1px solid",
                        borderRadius: "8px",
                        width: "100%",
                        height: "54px",
                        fontSize: "18px",
                        color: "#000",
                        fontWeight: "400",
                        caretColor: "blue",
                        padding:"25px 0px 16px 0px",
                        display:"flex",
                        justifyContent:"center"
                      }}
                      focusStyle={{
                        border: "1px solid #CFD3DB",
                        outline: "none"
                      }}
                    />
                    {/* <img src="/assets/icons/welcom-email.svg" alt="text_logo" /> */}
                    {formik.touched["otp"] && formik.errors["otp"] ? (
                      <span style={{ color: "red" }}>
                        {formik.errors["otp"]}
                      </span>
                    ) : null}
                  </FormGroup>)}
                  <div className="flex items-start space-x-4 text-gray-700 text-sm">
                        <input
                        type="checkbox"
                        id="terms"
                        checked={isChecked}
                        disabled={isChecked}
                        style={{width:"70px",height:"95px"}}
                        onChange={() => setIsChecked(!isChecked)}
                        className="w-7 h-4 mt-1 cursor-pointer"
                        />
                       <p htmlFor="terms" className="cursor-pointer" style={{ marginLeft: "10px", fontWeight: "400" }}>
                          I agree to receive text messages from CareMatics at the phone number provided. Message and data rates may apply. Reply STOP to unsubscribe at any time. I also consent to have my information evaluated for Medicaid eligibility and, if eligible, to be enrolled in Medicaid using the CareMatics platform. I have read and accepted the CareMatics{" "}
                          <a href="/terms" className="text-blue-600 hover:underline">
                            Terms & Conditions
                          </a>{" "}
                          and{" "}
                          <a href="/privacy" className="text-blue-600 hover:underline">
                            Privacy Policy
                          </a>
                          .
                        </p>
                    </div>
                  {!isOtpVerified &&
                  <Button onClick={handleSendOtp} disabled={!isChecked}className="spacing_five mb-4">
                    {isOtpSent ? "Resend OTP" : "Send OTP to Phone Number"}
                  </Button>}
                  {/* <br></br> */}
                  {/* <br></br> */}
                  {isOtpVerified && (
                      <>
                        {/* New Password Field */}
                        <FormGroup className="spacing_three_password">
                          <Input
                            id="examplePassword"
                            name="newPassword"
                            placeholder="New Password"
                            type={!formik.values.showPassword ? "text" : "password"}
                            value={formik.values.newPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            required
                          />
                          <img src="/assets/icons/Lock.svg" alt="lock_icon" />
                          <i
                            className={`fa ${!formik.values.showPassword ? "fa-eye" : "fa-eye-slash"}`}
                            onClick={() => formik.setFieldValue("showPassword", !formik.values.showPassword)}
                          ></i>
                          {formik.touched.newPassword && formik.errors.newPassword && (
                            <span style={{ color: "red" }}>{formik.errors.newPassword}</span>
                          )}
                        </FormGroup>

                        {/* Confirm Password Field */}
                        <FormGroup className="spacing_three_password">
                          <Input
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Confirm New Password"
                            type={!formik.values.showCPassword ? "text" : "password"}
                            value={formik.values.confirmPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            required
                          />
                          <img src="/assets/icons/Lock.svg" alt="lock_icon" />
                          <i
                            className={`fa ${!formik.values.showCPassword ? "fa-eye" : "fa-eye-slash"}`}
                            onClick={() => formik.setFieldValue("showCPassword", !formik.values.showCPassword)}
                          ></i>
                          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                            <span style={{ color: "red" }}>{formik.errors.confirmPassword}</span>
                          )}
                        </FormGroup>
                      </>
                    )}

                  {isOtpVerified &&
                  <Button type="submit" className="spacing_five mb-4"  disabled={!formik.values.otp} >
                    Reset Password
                  </Button>}
                </Form>
                <p className="color-neutral-700 mg-bottom-0 welcom_desc">
                    Have an account?{" "}
                    <a href="/login" className="text-blue-600 hover:underline">
                        Sign In
                    </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <p>Copyright © 2024 AimCare LLC</p>
        </footer>
      </div>
    </>
  );
}
export default PatientRegistration;
